import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '../routeConfig'
import ROUTE from '../routeEnum'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.name != ROUTE.AUTH && to.meta.requiresAuth && !Vue.prototype.$auth.verify()) {
        next({ name: ROUTE.AUTH })
    } else {
        next()
    }
})

export default router
